import { Component, Input } from '@angular/core';

@Component({
  selector: 'card-warning',
  templateUrl: './card-warning.component.html',
  styleUrls: ['./card-warning.component.scss']
})
export class CardWarningComponent {
  @Input() public text: string;
  @Input() public advisorContact?: boolean = false;
  @Input() public advisorWhatsAppLink?: string;
}
